import OptionGroup from 'trunks/vue/share/components/option_group.js';

export default Vue.extend({
  components: {
    'option-group': OptionGroup,
  },

  template: `
    <div class="webhook-modal-content">
      <div class="form-field inline">
        <div class="form-field-head">
          <div class="form-field-title">Payload URL</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input
              class="form-field-value"
              placeholder="请输入" type="text"
              v-model="payloadUrl"
            />
          </div>
        </div>
      </div>
      <div class="form-field inline">
        <div class="form-field-head">
          <div class="form-field-title">Events</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <option-group
              :options="options"
              :initialValue="initialSelectedOptions"
              :multiple="true"
              @valueChange="onOptionValueChangeFunc"
              ref="optionRef"
            />
          </div>
        </div>
      </div>
    </div>
  `,

  props: {
    webhook: {
      type: Object,
      default() {
        return {};
      },
    },
    allEvents: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      payloadUrl: this.webhook.payload_url,
      events: this.webhook.subscribed_events,
      initialSelectedOptions: [],
    };
  },

  computed: {
    options() {
      return this.allEvents.map((event) => new Skylark.App.Model.FieldOption({
        id: event,
        value: event,
      }));
    },
  },

  created() {
    this.initialSelectedOptions = _.filter(this.options, (option) => _.contains(this.events, option.label));
  },

  watch: {
    payloadUrl(value) {
      this.$emit('valueChanged', {
        ...this.webhook,
        payload_url: value,
        subscribed_events: this.events,
      });
    },
  },

  methods: {
    onOptionValueChangeFunc(option) {
      this.events = _.map(option, (item) => item.value);
      this.$emit('valueChanged', {
        ...this.webhook,
        payload_url: this.payloadUrl,
        subscribed_events: this.events,
      });
    },
  },
});
